module.exports = __webpack_public_path__ + "assets/img/elite-iq-banner-no-button.c4f4e0a9.png";